import { Dow } from '@services/engineService';

export type SportDay = { dow: Dow; sportId: string };

export const DAYS: Array<{ dow: Dow; label: string }> = [
  { dow: 1, label: 'L' }, { dow: 2, label: 'M' }, { dow: 3, label: 'M' }, { dow: 4, label: 'J' },
  { dow: 5, label: 'V' }, { dow: 6, label: 'S' }, { dow: 7, label: 'D' },
];

export const hasSportDay = (sportDays: SportDay[], sportId: string, dow: Dow): boolean =>
  sportDays.some((d) => d.dow === dow && d.sportId === sportId);

export const toggleSportDay = (sportDays: SportDay[], sportId: string, dow: Dow): SportDay[] =>
  hasSportDay(sportDays, sportId, dow)
    ? sportDays.filter((d) => !(d.dow === dow && d.sportId === sportId))
    : [...sportDays, { dow, sportId }];

